/**

## Selector Control Navigation Button

**Contextual Component** This component is not intended to be used as a standalone. Checkout it's potential parent components for usage instead:
- [Selector Control](../selector-control.html)

The selector control button serves as a control for the navigtion on the [Selector Control component](../../selector-control.html)

###Parameters
@param {boolean} [preventNavigation=false] - will prevent the default behavior of navigating between nav items if true
@param {string} [actionType="NEXT"] - The direction this control will navigate. "NEXT" or "PREVIOUS"

also inherits parameters from [SQ Button](../../sq-button.html)
*/

import { computed } from '@ember/object';
import { reads } from '@ember/object/computed';
import SqButton from '../../sq-button';
export const SELECTOR_NAV_ACTION_TYPE = {
  NEXT: 'NEXT',
  PREVIOUS: 'PREVIOUS'
};
export default SqButton.extend({
  classNames: ['selector-control__navigation__button'],
  classNameBindings: ['actionTypeClass'],
  attributeBindings: ['data-test-selector-control-button'],
  'data-test-selector-control-button': reads('actionType'),
  actionType: SELECTOR_NAV_ACTION_TYPE.NEXT,
  actionTypeClass: computed('actionType', function () {
    if (this.get('actionType') === SELECTOR_NAV_ACTION_TYPE.NEXT) {
      return 'selector-control__navigation__button--next';
    } else {
      return 'selector-control__navigation__button--previous';
    }
  }),
  click() {
    if (this.onClick) {
      this.onClick();
    }
    if (!this.get('preventNavigation') && this.navigate) {
      this.navigate(this.get('actionType'));
    }
  }
});